import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesMin } from './ITypeValidatesMin';

// todo: figure out how to also deal with strings (or things with length).

export class MinValidator implements ValidatorInterface<ITypeValidatesMin> {
  name = 'Min';

  friendlyName = 'Minimum Value';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.min.description';

  types = ['String', 'LongText', 'Percentage', 'Currency', 'Number'];

  properties = {
    value: {
      type: 'Number',
      default: 1,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesMin) {
    type.addMinValidator(this);
  }
}

const minValidator = new MinValidator(undefined);

ValidatorRegistry.register(MinValidator, minValidator.name);

export { minValidator };
